<template>
  <div :class="['form-group mb-0 input-wrapper', customClass.containerClass]">
    <label :for="id" :class="customClass.labelClass">{{ label }}</label>
    <div>
      <div class="d-flex">
        <div v-if="showPrefixLabel" class="side-label prefix-label">
          <slot name="prefix-label"> </slot>
        </div>
        <input
          :id="id"
          type="string"
          :class="[
            'form-control',
            showPrefixLabel ? 'input-with-prefix' : '',
            showSuffixLabel ? 'input-with-suffix' : '',
            customClass.inputClass,
          ]"
          :placeholder="placeholder"
          :value="displayValue"
          @input="handleInput"
          @keydown="preventInvalidKey"
          @blur="formatDisplay"
          :disabled="disabled"
        />
        <div v-if="showSuffixLabel" class="side-label suffix-label">
          <slot name="suffix-label"> </slot>
        </div>
      </div>
      <small class="text-danger m-0" v-if="currentError">{{
        currentError
      }}</small>
    </div>
  </div>
</template>

<script>
import { validateEmail } from "../../utils";
import { parserMixin } from "../../mixins";

export default {
  props: {
    customClass: {
      type: Object,
      default: () => ({ containerClass: "", labelClass: "", inputClass: "" }),
    },
    id: { type: String, required: true },
    value: { type: Number, required: true },
    placeholder: { type: String, default: "", required: false },
    error: { type: String, default: "", required: false },
    label: { type: String, default: "", required: false },
    required: { type: Boolean, default: false },
    showPrefixLabel: { type: Boolean, default: false },
    showSuffixLabel: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      currentError: "",
    };
  },
  computed: {
    displayValue() {
      // Show formatted value when rendering
      const number = Number(this.value) || 0;
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
      }).format(number);
    },
  },
  mixins: [parserMixin],
  methods: {
    preventInvalidKey(e) {
      // Allow: Backspace, Delete, Arrow keys, Tab
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          e.key
        )
      ) {
        return;
      }

      // Block non-digit keys
      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault();
      }
    },
    handleInput(e) {
      const raw = e.target.value.replace(/\D/g, ""); // keep only digits
      const numericValue = parseInt(raw || "0", 10);

      // Emit the raw number (no formatting)
      this.$emit("change", numericValue);
      if(e.target.value) this.currentError = "";

      // Reformat the displayed text
      e.target.value = new Intl.NumberFormat("id-ID").format(numericValue);
    },
    formatDisplay(e) {
      // Reformat on blur (e.g., user pastes weird characters)
      const raw = e.target.value.replace(/\D/g, "");
      const numericValue = parseInt(raw || "0", 10);
      e.target.value = new Intl.NumberFormat("id-ID").format(numericValue);
      if(e.target.value) {
        this.currentError = "";
      }
    },
  },
  watch: {
    error(value) {
      this.currentError = value;
    },
  },
};
</script>

<style scoped>
input {
  width: 100%;
  border-radius: 6px;
  height: 40px;
  font-size: 1rem;
}

label {
  color: #374151;
  font-weight: 600;
  font-size: 14px;
}

.text-muted,
input::placeholder {
  font-size: 1rem;
  color: #2e364666 !important;
  opacity: 1 !important; /* Firefox */
}

.prefix-label {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.suffix-label {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.input-with-prefix {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
}

.input-with-suffix {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.side-label {
  background-color: #fafafa;
  border: 1px solid #d1d9e2;
  color: #2e3646;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
  font-size: 1rem;
  height: 40px;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputCurrency.vue